import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Oportunidad/Kanban',
  alias: [],
  documento: 'crm',
  filas: ['132'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/OportunidadController.cs:164',
} satisfies RutaProd;
